import React from "react";
import CustomModal from "../../components/Modal";
import Input, { DateInput, NumberInput } from "../../components/Input";
import { useForm } from "react-hook-form";

const Modal = ({ modal, setModal, handleSubmit: handleSubmitModal }) => {
  const { register, errors, handleSubmit } = useForm();
  const onSubmit = handleSubmit((data) => handleSubmitModal(data));

  return (
    <CustomModal
      show={modal.show}
      title={modal.action === "ADD" ? `Agregar Ajuste a ${modal.data.depto}` : `Editar Ajuste de ${modal.data.depto}`}
      setModal={setModal}
      handleSubmit={onSubmit}
    >
      <form onSubmit={onSubmit}>
        <NumberInput
          label="Monto"
          name="MONTO"
          errors={errors}
          errMsg="Monto requerido"
          autoFocus
          value={modal.data.MONTO}
          register={register({ required: true })}
        />
        <DateInput
          label="Fecha"
          name="FECHA"
          errors={errors}
          errMsg="Fecha Requerido"
          value={modal.data.FECHA}
          autoComplete={{ mm: true, yyyy: true }}
          register={register({ required: true })}
        />
        <Input label="Detalle" name="DETALLE" value={modal.data.DETALLE} register={register} />
        <input type="submit" style={{ display: "none" }} />
      </form>
    </CustomModal>
  );
};

export default Modal;
